<template>
    <!-- 转移客户对话框 -->
    <el-dialog :title="title" :visible.sync="isOpen" width="528px" append-to-body @close="cancelDialog" :close-on-click-modal="false">
      <el-form ref="myDialogForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="选择场馆" prop="venueCode">
          <el-select v-model="form.venueCode" style="width: 100%" filterable  default-first-option
            placeholder="请选择场馆">
              <el-option v-for="item in venueList" :key="item.value" :label="item.label" :value="item.value" style="width: 100%;max-width:500px;">
              </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  
  import { updateVenueCodeApi, venueListApi } from "@/api/user";
  import { setVenueCode,getVenueCode } from "@/utils/auth";


  
  export default {
    name: 'SelectVenueDialog',
    components: {},
    props: {
      // 对话框是否打开
      open: {
        type: Boolean,
        required: true
      },
    },
    mounted() {
      console.log('created,getVenueCode()',getVenueCode());
      const venueCode = getVenueCode() || "";
      this.form.venueCode = venueCode;
      this.getVenueList();

    },
    data() {
      return {
        title: "选择场馆",
        form: {
          venueCode: "",
        },
        venueList: [],
        // 表单校验规则
        rules: {
            venueCode: [
              { required: true, message: "请选择场馆", trigger: "change" }
            ] 
        }
      };
    },
    methods: {
       getVenueList() {
        venueListApi().then(res => {
          console.log('venueListApi',res);
          const venueList = res || [];
          this.venueList = venueList.map(item => {
            return {
              value: item.tenantCode,
              label: item.venueName

            };
          });
        });
      },
      // 取消对话框并重置表单
      cancelDialog() {
        this.resetForm();
        this.$emit('cancel');
      },
      // 提交表单
      submit() {
        this.$refs["myDialogForm"].validate((valid) => {
          if (valid) {
            console.log('submit',this.form.venueCode);
            const venueCode = this.form.venueCode;
            let opt = new FormData();
            opt.append('venueCode ',venueCode);
            updateVenueCodeApi(opt).then((response) => {
              console.log('切换场馆成功',JSON.stringify(response));
              setVenueCode(venueCode);
              localStorage.setItem('companyName', response.cpyName );
              // 需要更新本地存储的userInfo信息
              this.$store.dispatch("user/switchVenue", {
                isAdmin: response.isAdmin,
                cpyName: response.cpyName,
                step: response.step,
                role: response.role,
                guid: response.guid
              })
              this.$emit('submit',response);
            });
          }
        });
      },
      // 重置表单
      resetForm() {
        this.$refs["myDialogForm"].resetFields();
      }
    },
    computed: {
      isOpen: {
        get() {
          return this.open;
        },
        set(newValue) {
          this.$emit('update:open', newValue);
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  /* 样式代码可以在这里添加 */
  </style>